import RouteTemplate from 'ember-route-template'
import BaseRouteTemplate from 'customer-flows/templates/base-route-template'
import TwoColumn from 'customer-flows/components/layout-kit/two-column'
import StepContainer from 'customer-flows/components/flow-kit/step-container'
import HeroContainer from 'customer-flows/components/flow-kit/hero-container'
import ProgressBar from 'customer-flows/components/flow-kit/progress-bar'
import StaticFooter from 'customer-flows/components/booking/static-footer'
import StickyFooter from 'customer-flows/components/booking/sticky-footer'
import CartSummary from 'customer-flows/components/booking/cart-summary'
import t from 'ember-intl/helpers/t'
import { not } from 'ember-truth-helpers'
import { action } from '@ember/object'

const progressBarExcludedPages: PageType[] = ['FlowConfigBookingStartPage']

class BookingExtensionTemplate extends BaseRouteTemplate<BookingInfoPage> {
  @action
  onBookClicked() {
    this.flowManager.forward()
  }

  @action
  onEditBookingClicked() {
    this.flowManager.back()
  }

  get showCartSummary() {
    return this.flowManager.allStepsValid
  }

  <template>
    <div data-testid='booking-flow' class='mx-auto my-0 flex h-full w-full flex-col items-center'>
      <ProgressBar @excludePages={{progressBarExcludedPages}} />

      <TwoColumn @stickyColumn='right'>
        <:leftColumn>
          <div class='flex flex-col gap-4'>
            <StepContainer />
          </div>
        </:leftColumn>

        <:rightColumn>
          <HeroContainer />
        </:rightColumn>

        <:staticFooter>
          <StaticFooter @text={{t 'booking.footer.text' htmlSafe=true}} />
        </:staticFooter>

        <:stickyFooter>
          <StickyFooter>
            <CartSummary class='@md/flow:hidden' @collapsible={{true}} @isMobile={{true}} />
            <il-button
              fill
              {{! @glint-ignore: wait until we can't declare custom elements in glint }}
              onClick={{this.onBookClicked}}
              disabled={{not this.showCartSummary}}
              clickable-when-disabled={{true}}
              data-testid='date-first-rentals-flow__continue-cta'
            >
              {{t 'booking.cta.continue-booking'}}
            </il-button>
          </StickyFooter>
        </:stickyFooter>
      </TwoColumn>
    </div>
  </template>
}

export default RouteTemplate(BookingExtensionTemplate)
